module.exports = __webpack_public_path__ + "static/10400556_21565047223_9371_n-64c2c48c5c8bbb39485d5d9fb9edc45e.jpg";